import { Navigate, Outlet } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import NotFound from "./NotFound";

const AdminRoute = () => {
  const { userInfo, authLoading } = useContext(AuthContext);

  if (authLoading) return null; // or a loading spinner

  // Check if user is authenticated
  if (!userInfo) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has admin role
  if (userInfo.role !== "admin") {
    return <NotFound />;
  }

  return <Outlet />;
};

export default AdminRoute;
